import {Component, Input, OnInit,} from '@angular/core';
import {MatStepper} from '@angular/material/stepper';
import {Router} from '@angular/router';
import { ApiAmenaService } from '../../services/api-amena.service';
import { DraftService } from '../../services/draft.service';
import { ShoppingCartService } from '../../services/shopping-cart-service';
import { ConfirmationService } from '../../services/confirmation.service';
import { ConfirmationPreloaderService } from '../../services/confirmation-preloader.service';

@Component({
    selector: 'app-confirmation',
    templateUrl: './confirmation.component.html',
    styleUrls: ['./confirmation.component.css', '../../../../assets/css/amena-theme.css'],
    standalone: false
})
export class ConfirmationComponent implements OnInit {
    public activated = false;
    public date = new Date();
    public contractId = '-';
    public activationError = false;
    public error: any;
    isLoading = false;
    textDefault = 'Activar servicios';
    @Input() stepper: MatStepper;

    constructor(
        private router: Router,
        private ApiAmena: ApiAmenaService,
        private draftService: DraftService,
        private shoppingCartService: ShoppingCartService,
        private confirmationService: ConfirmationService,
        private confirmationPreloaderService: ConfirmationPreloaderService
    ) { }

    ngOnInit(): void {
        this.stepper.selectionChange.subscribe(data => {
            if (data.selectedIndex === this.stepper._steps.length - 1) {
                this.date = new Date();
                this.confirmationService.setDateClient(this.date);
                this.confirmationService.setDataClient(this.shoppingCartService.getShoppingCart().getOperation().getUserData().getRawValue());
                this.confirmationService.setContractId('-');
                this.confirmationService.setMuestraComentarios(false);
                this.confirmationService.setTipoAlta(this.shoppingCartService.getOperationData());
            }
        });
    }

    activate() {
        const order = this.shoppingCartService.generateOrders();

        this.onChangeLoading(true);
        this.confirmationPreloaderService.setOrderId(order.order_id);
        this.confirmationPreloaderService.setHttpError(false);
        this.confirmationPreloaderService.getPreloadingComplete().subscribe(isComplete => {
            if (isComplete) {
                location.href = '/amena/order/form/' + order.order_id;
            }
        });

        if (!this.activationError) {
            this.ApiAmena.createOrder(order)
                .subscribe((data: any) => {
                    console.log(data);
                    this.draftService.setOrderIdDraft(null);
                    this.draftService.orderInit();
                    this.draftService.setActivacionCompletada(true);
                }, error => {
                    console.log(error);
                    this.confirmationPreloaderService.setHttpError(true);
                    if (!this.activationError) {
                        this.activationError = true;
                        this.error = error;
                        this.activated = true;
                        this.onChangeLoading(false);
                    }
                });
        }
    }

    retryActivation() {
        this.activated = false;
        this.activationError = false;
        this.error = {};
        this.activate();
    }

    onChangeLoading(state) {
        if (state === true) {
            this.isLoading = true;
            this.textDefault = 'Activando ...';
        } else {
            this.isLoading = false;
            this.textDefault = 'Activar servicios';
        }
    }

}
